<template>
  <div class="page-device">
    <!-- Begin head block -->
    <section class="head-block">
      <div class="container">
        <div class="row">
          <div class="col-x-lg-6 col-lg-8 col-xs-12">
            <h1 class="head-block__title" v-html="$t('device.title')"></h1>
            <h6
              class="head-block__subtitle"
              v-html="$t('device.subtitle')"
            ></h6>
            <p class="head-block__text" v-html="$t('device.text')"></p>
          </div>
        </div>
        <div class="row">
          <div class="col-x-lg-4 col-lg-5 col-md-6 col-xs-12">
            <div class="head-block__device">
              <div class="head-block__device-image">
                <img src="~@/assets/img/device/device.png" alt="" />
                <div class="head-block__device-images">
                  <img
                    data-detail="1"
                    src="~@/assets/img/device/1.png"
                    alt=""
                  />
                  <img
                    data-detail="2"
                    src="~@/assets/img/device/2.png"
                    alt=""
                  />
                  <img
                    data-detail="3"
                    src="~@/assets/img/device/3.png"
                    alt=""
                  />
                  <img
                    data-detail="4"
                    src="~@/assets/img/device/4.png"
                    alt=""
                  />
                  <img
                    data-detail="5"
                    src="~@/assets/img/device/5.png"
                    alt=""
                  />
                  <img
                    data-detail="6"
                    src="~@/assets/img/device/6.png"
                    alt=""
                  />
                  <img
                    data-detail="7"
                    src="~@/assets/img/device/7.png"
                    alt=""
                  />
                  <img
                    data-detail="8"
                    src="~@/assets/img/device/8.png"
                    alt=""
                  />
                  <img
                    data-detail="9"
                    src="~@/assets/img/device/9.png"
                    alt=""
                  />
                  <img
                    data-detail="10"
                    src="~@/assets/img/device/10.png"
                    alt=""
                  />
                  <img
                    data-detail="11"
                    src="~@/assets/img/device/11.png"
                    alt=""
                  />
                  <img
                    data-detail="12"
                    src="~@/assets/img/device/12.png"
                    alt=""
                  />
                  <img
                    data-detail="13"
                    src="~@/assets/img/device/13.png"
                    alt=""
                  />
                  <img
                    data-detail="14"
                    src="~@/assets/img/device/14.png"
                    alt=""
                  />
                  <img
                    data-detail="15"
                    src="~@/assets/img/device/15.png"
                    alt=""
                  />
                </div>
              </div>
              <div class="head-block__device-details">
                <div
                  class="head-block__device-detail"
                  v-for="(detail, key) in $t('device.details')"
                  :key="key"
                  :data-detail-id="key + 1"
                >
                  {{ detail }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-x-lg-8 col-lg-7 col-md-6 col-xs-12">
            <div class="head-block__detail">
              <div class="head-block__detail-row">
                <div
                  class="head-block__detail-col"
                  v-for="(detail, key) in $t('device.detailInfo')"
                  :key="key"
                >
                  <div class="head-block__detail-item">
                    <div
                      class="head-block__detail-title"
                      v-html="detail.title"
                    ></div>
                    <div
                      class="head-block__detail-text"
                      v-html="detail.text"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="head-block__list">
              <div
                class="head-block__list-title"
                v-html="$t('device.list.title')"
              ></div>
              <div
                class="head-block__list-item"
                v-html="$t('device.list.item_1')"
              ></div>
              <div
                class="head-block__list-item"
                v-html="$t('device.list.item_2')"
              ></div>
              <div
                class="head-block__list-item"
                v-html="$t('device.list.item_3')"
              ></div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-x-lg-7 col-lg-8 col-xs-12">
            <div class="head-block__info">
              <div
                class="head-block__info-title"
                v-html="$t('device.info.title')"
              ></div>
              <div
                class="head-block__info-text"
                v-html="$t('device.info.text')"
              ></div>
              <router-link
                @click.native="thingMainBtn()"
                :to="$t('device.info.button.link')"
                class="head-block__info-btn"
              >
                {{ $t("device.info.button.title") }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- // -->
    <!-- Begin bibliography -->
    <section class="bibliography">
      <div class="container">
        <div class="bibliography__info">
          <p v-html="$t('bibliography.info_1')"></p>
        </div>
        <div class="bibliography__list">
          <h3
            class="bibliography__list-title"
            v-html="$t('bibliography.bibliographyTitle')"
          ></h3>
          <div
            class="bibliography__list-item"
            v-for="(item, key) in $t('device.bibliography.list')"
            :key="key"
          >
            <div class="bibliography__list-number">{{ key + 1 }}.</div>
            <div class="bibliography__list-text" v-html="item"></div>
          </div>
        </div>
      </div>
    </section>
    <!-- // -->
  </div>
</template>

<script>
export default {
  name: "DeviceView",
  metaInfo() {
    if (this.$i18n.locale === "ua") {
      return {
        title: "Що особливого в дозуючому пристрої Називін® Сенситив?",
        meta: [
          {
            name: "description",
            content:
              "Дозуючий пристрій ⚙ дозволяє: зберігати стерильність 🧼 флакона без додавання консерванта 🧪 та користуватися препаратом до 12 місяців після відкриття⏳"
          },
          {
            property: "og:description",
            content: "Що особливого в дозуючому пристрої Називін® Сенситив?"
          },
          {
            property: "og:image",
            content: "/img/global/packshot.jpg"
          }
        ]
      };
    } else if (this.$i18n.locale === "ru") {
      return {
        title: "Особенности дозирующего устройства Називин® Сенситив",
        meta: [
          {
            name: "description",
            content:
              "Дозирующее устройство ⚙ позволяет сохранять стерильность 🧼 флакона без добавления консерванта 🧪 и пользоваться препаратом до 12 месяцев после видкриття⏳"
          },
          {
            property: "og:description",
            content: "Особенности дозирующего устройства Називин® Сенситив"
          },
          {
            property: "og:image",
            content: "/img/global/packshot.jpg"
          }
        ]
      };
    }
  },
  methods: {
    thingMainBtn() {
      // eslint-disable-next-line no-undef
      gtag("event", "click", { event_category: "thing_main_btn" });
    }
  },
  mounted() {
    this.$nextTick(() => {
      var detailNamesArray = document.querySelectorAll(
        ".head-block__device-detail"
      );
      detailNamesArray.forEach(detail => {
        var dataDetailId = detail.getAttribute("data-detail-id");
        detail.addEventListener("mouseover", () => {
          document
            .querySelector("[data-detail='" + dataDetailId + "']")
            .classList.add("active");
        });
        detail.addEventListener("mouseout", () => {
          document
            .querySelector("[data-detail='" + dataDetailId + "']")
            .classList.remove("active");
        });
      });
    });
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto"
    });
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/views/_device";
</style>
